import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { Snackbar } from "./components";
import RouteTracker from "./routes/RouteTracker";

function App() {
  return (
    <BrowserRouter>
      <RouteTracker />
      <AppRoutes />
      <Snackbar />
    </BrowserRouter>
  );
}

export default App;
